import React, { useContext, useEffect, useState } from "react";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import LanguageContext from "../../LanguageContext";
import messages from "../../services/messages";
import content from "../../services/content";
import CarousalContainer from "../CarousalContainer";

const WhatOurFarmerSays = ({ classes, userState }) => {
  const language = useContext(LanguageContext);
  const [videoKey, setVideoKey] = useState("success.video.");
  const [successVideos, setSuccessVideos] = useState(
    content["success.video"]["maharashtra"]
  );
  useEffect(() => {
    if (userState) {
      let successVideosByCrop =
        content["success.video"][userState.name_en.toLowerCase()];

      setVideoKey(videoKey + userState.name_en.toLowerCase());

      let successVideoKeys = Object.keys(successVideosByCrop);
      let successVideosMap = successVideoKeys.map((successVideoKey) => {
        return {
          key: videoKey + "." + successVideoKey,
          ...successVideosByCrop[successVideoKey],
        };
      });
      setSuccessVideos(successVideosMap);
    } else {
      let successVideosByCrop = content["success.video"]["maharashtra"];

      successVideosByCrop = content["success.video"]["maharashtra"];
      setVideoKey(videoKey + "maharashtra");

      let successVideoKeys = Object.keys(successVideosByCrop);
      let successVideosMap = successVideoKeys.map((successVideoKey) => {
        return {
          key: videoKey + "." + successVideoKey,
          ...successVideosByCrop[successVideoKey],
        };
      });
      setSuccessVideos(successVideosMap);
    }
  }, [userState]);

  return (
    <div className={classes.whiteSection}>
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item className={classes.item}>
          <Typography variant={"h6"} style={{ fontWeight: "bold" }}>
            {messages["landing.whatOurFarmerSays"][language]}
          </Typography>
        </Grid>
      </Grid>
      <CarousalContainer
        videos={successVideos}
        title={""}
        background={"#fff"}
        userState={userState}
      />
      <br />
    </div>
  );
};

export default WhatOurFarmerSays;
